<div class="text-container">
  <span title="{{'multi.select.filter.footer' | translate: {'0':filteredOptionsCount,'1':optionsCount} }}">{{"multi.select.filter.footer" | translate: {'0':filteredOptionsCount,'1':optionsCount} }}</span>
</div>
